// Mirrors utils/commsBlocks.js on the server and utils/commsApproval.ts in the app.
// The vendor group renders the blocks, so an edit has to land in them, not in `message`.
export const editableFields = (blocks) => {
  const fields = [];
  let bodyCount = 0;

  for (const block of blocks || []) {
    if (block?.type === "text") {
      bodyCount += 1;
      fields.push({ label: `Message part ${bodyCount}`, value: String(block.value ?? "") });
      continue;
    }
    if (block?.type === "list") {
      (block.items || []).forEach((item, index) => {
        fields.push({
          label: `List item ${index + 1}`,
          value: String(item?.label ?? ""),
        });
      });
    }
  }

  return fields;
};

export const editableValues = (blocks) =>
  editableFields(blocks).map((field) => field.value);

// Null when the values no longer line up, so the caller refuses the edit.
export const applyEditableValues = (blocks, values) => {
  if (!Array.isArray(blocks) || !Array.isArray(values)) return null;
  if (editableValues(blocks).length !== values.length) return null;

  let cursor = 0;
  return blocks.map((block) => {
    if (block?.type === "text") {
      return { ...block, value: String(values[cursor++] ?? "") };
    }
    if (block?.type === "list") {
      return {
        ...block,
        items: (block.items || []).map((item) => ({
          ...item,
          label: String(values[cursor++] ?? ""),
        })),
      };
    }
    return { ...block };
  });
};

// The message in the order the group renders it: the chat hoists one image to the top,
// words become inputs, everything else renders as sent.
export const editorRows = (blocks) => {
  const rows = [];
  let field = 0;

  const image = (blocks || []).find((block) => block?.type === "image");
  if (image) rows.push({ kind: "fixed", blocks: [image] });

  for (const block of blocks || []) {
    if (block?.type === "image") continue;
    if (block?.type === "text") {
      rows.push({ kind: "field", index: field++ });
      continue;
    }
    if (block?.type === "list") {
      for (let index = 0; index < (block.items || []).length; index += 1) {
        rows.push({ kind: "field", index: field++ });
      }
      continue;
    }
    const last = rows[rows.length - 1];
    if (last?.kind === "fixed") last.blocks.push(block);
    else rows.push({ kind: "fixed", blocks: [block] });
  }

  return rows;
};
